export default __webpack_public_path__ + "19665bac881ddb3bde2e0d6ad1d17b9e.wav";